
import React, { useEffect, useState } from 'react';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import { prepareUrl } from '../../../../../utilities/StringHelpers/StringHelpers';
import Image from "../../../../Shared/Image/image";
import iconLight from '../../images/icon-light.svg';
const PackagePrice = (props) => {
  const [lawText, setLawText] = useState([]);
  const [routeLawText, setRouteLawText] = useState('');
  const [priceText, setPriceText] = useState('');
  const [timePeriod, setTimePeriod] = useState('');
  const [termsLinkList, setTermsLinkList] = useState([]);
  const isHboPackage = props.packageWorld?.cmsData?.id?.toLowerCase?.().includes('hbo');
  const hboText = (
    <>
      בלחיצה על הכפתור חבילת HBO Max תעודכן למסלול שבחרת.<br className="desktop-only" />
      לתשומת ליבך, לא ניתן ליהנות מהטבת הצטרפות יותר מפעם אחת.<br />
      ערוצים, תוכן חי ושידורים חוזרים (במידה והם כלולים בתוכנית שלך) כוללים פרסומות. כל התוכניות עשויות לכלול חסויות ותכני קידום.
    </>
  );

  useEffect(() => {
    if (props.isPackagesWorld) {
      let termsLinkList = [];
      let lawTextList = [];
      props.packages.map((item) => {
        termsLinkList.push({ text: item.title, link: item.termsLink });
        if (item.lawText) {
          lawTextList.push(item.lawText);
        }
      });
      setLawText(lawTextList);
      setTermsLinkList(termsLinkList);
    } else if (props.packages?.length == 1) {
      const premiumPackage = props.packages[0];
      if (premiumPackage) {
        const title = premiumPackage.cmsData?.selfCare.title ? premiumPackage.cmsData?.selfCare?.title : premiumPackage.localizedName;
        const termsLink = premiumPackage.cmsData?.termsLink;
        setTermsLinkList([{ text: title, link: termsLink }])
        if (props.isPackageRoute) {
          const duration = parseInt(premiumPackage?.duration.amount);
          const title = premiumPackage?.cmsData?.selfCare?.title ? premiumPackage?.cmsData?.selfCare?.title : premiumPackage.localizedName;
          setPriceText(title);
          setRouteLawText(premiumPackage?.cmsData?.selfCare?.lawText);
          if (duration == 0) {
            setTimePeriod('לחודש');
          }
          else {
            setTimePeriod('חד פעמי');
          }
        }
        else {
          setPriceText('מנוי חודשי מתחדש');
          setTimePeriod('לחודש');
        }
      }
    }
  }, [props.packages]);


  function openTermsInNewTab(e, terms) {
    e.preventDefault();
    if (terms) {
      prepareUrl(`${terms}`, props.context);
    }
  }

  function getPriceDetails() {
    const selectedPackage = props.isPackagesWorld ? props.packageWorld : props.packages[0];
    if (selectedPackage?.priceItemList?.length > 0) {
      return (<div className='price-list-wrapper'>
        {selectedPackage.priceItemList.map((item, index) => {
          return (
            <div className='price-details' key={index}>
              <div className='text'>{item.totalPrePriceText}</div>
              <div className='price-wrapper'>
                <div className='price'>{item.price}<span className='nis'>₪</span>
                  <span className='time-period' >&nbsp;{item.totalPriceText}</span>
                </div>
              </div>
            </div>)
        })}
      </div>)
    } else if (selectedPackage.price == selectedPackage.originalPrice) {
      return (<div className='price-details'>
        <div className='text'>{priceText}</div>
        <div className='price-wrapper'>
          {selectedPackage.price == 0 ?
            <div className='price'>
              <span className='free-price' >&nbsp;{'ללא עלות'}</span>
            </div> :
            <div className='price'>{selectedPackage.price}<span className='nis'>₪</span>
              <span className='time-period' >&nbsp;{timePeriod}</span>
            </div>
          }
        </div>
      </div>)
    }
    else if (selectedPackage.price != selectedPackage.originalPrice) {
      return (<div className='price-details'>
        <div className='text'>{priceText}</div>
        <div className='price-wrapper'>
          <div className='price'>{selectedPackage.price}<span className='nis'>₪</span>
            <span className='original-price-text'> במקום </span><span className='original-price'>₪{selectedPackage.originalPrice}</span>
          </div>
        </div>
      </div>)
    }
  }

  return (<div className='premium-package-catalog-price-details'>
    <div className='info-wrapper'>
      {props.isPackagesWorld ?
        lawText?.map((info, index) => {
          return (<p key={index} className='info'><span className='info-icon' style={{ backgroundImage: iconLight.bg() }} />
            <span className='info-text'>{isHboPackage ? hboText : info}</span></p>)
        }) :
        props.lawText && <p className='info'><span className='info-icon' style={{backgroundImage:iconLight.bg()}} /><span className='info-text'>{isHboPackage ? hboText : props.lawText}</span></p>
      }
    </div>
    {props.packages?.length > 0 && props.packages[0] != null &&
      <>
        <div className='premium-package-catalog-total-price'>
          {getPriceDetails()}
          {routeLawText &&
            <p>{routeLawText}</p>
          }
        </div>
        <div className='terms'>
          <CheckBox
            id={'premium-package-catalog-terms'}
            checked={props.isCheckedTerms}
            label={''}
            error={props.termsError}
            onChange={() => props.onClickTerms(!props.isCheckedTerms)}>
            <span>אני מאשר/ת את תנאי </span>
            {termsLinkList?.length > 1 ? <span>החבילות: </span> : <span>החבילה: </span>}
            {termsLinkList?.map((item, index) => {
              return (<a key={index} href="#" target="_blank" onClick={(e) => openTermsInNewTab(e, item.link)}>{item.text}{termsLinkList.length > index + 1 ? ',' : null} </a>)
            })}
          </CheckBox>
        </div>
      </>
    }
  </div>)

}
export default PackagePrice;
